import { render, staticRenderFns } from "./ViewRiderDetail.vue?vue&type=template&id=0e5a8868&scoped=true"
import script from "./ViewRiderDetail.vue?vue&type=script&lang=js"
export * from "./ViewRiderDetail.vue?vue&type=script&lang=js"
import style0 from "./ViewRiderDetail.vue?vue&type=style&index=0&id=0e5a8868&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5a8868",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e5a8868')) {
      api.createRecord('0e5a8868', component.options)
    } else {
      api.reload('0e5a8868', component.options)
    }
    module.hot.accept("./ViewRiderDetail.vue?vue&type=template&id=0e5a8868&scoped=true", function () {
      api.rerender('0e5a8868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryInfo/ViewRiderDetail.vue"
export default component.exports